import { useState } from "react";

import {
  DatabaseDetailContentQuery,
  DatabaseDetailTableContentQuery,
} from "~/lib/graphql/client";

export enum ModalContentKind {
  RESPONSE_FORM = "RESPONSE_FORM",
  ITEM_DETAIL = "ITEM_DETAIL",
  HIDE = "HIDE",
}

type Question = DatabaseDetailContentQuery["form"]["questions"][number];
type Response = DatabaseDetailTableContentQuery["form"]["responses"][number];

export type ModalContentState =
  | {
      __kind: ModalContentKind.HIDE;
    }
  | {
      __kind: ModalContentKind.RESPONSE_FORM;
      questions: Question[];
    }
  | {
      __kind: ModalContentKind.ITEM_DETAIL;
      response: Response;
    };

export function useModalContent() {
  const [modalContent, setModalContent] = useState<ModalContentState>({
    __kind: ModalContentKind.HIDE,
  });

  const openResponseForm = (questions: Question[]) =>
    setModalContent({ __kind: ModalContentKind.RESPONSE_FORM, questions });
  const openItemDetail = (response: Response) =>
    setModalContent({ __kind: ModalContentKind.ITEM_DETAIL, response });
  const hideModal = () => setModalContent({ __kind: ModalContentKind.HIDE });

  return {
    modalContent,
    openResponseForm,
    openItemDetail,
    hideModal,
  };
}
